import cn from 'classnames';
import { Link } from 'react-router';
import { Image, ImageVariant } from '../../../common/components/Image';
import { SponsorCardFormData } from './contracts';

export type SponsorCardProps = SponsorCardFormData;

function SponsorCard({ dataConfig: { name, imageSrc, url }, showTitle, openInNewTab }: SponsorCardFormData) {
  const logoClass = cn('sponsor-card', !showTitle && 'sponsor-card--logo-only');

  const logoArea = (
    <div className="sponsor-card__logo">
      <div className="sponsor-card__image-wrapper">
        <Image
          className="sponsor-card__image"
          src={imageSrc}
          alt={name}
          variant={ImageVariant.SponsorLogoXs}
          sizes="(max-width: 767px) calc(100vw - 32px), 228px"
          style={{ objectFit: 'contain' }}
        />
      </div>
    </div>
  );

  return (
    <div className={logoClass}>
      {url ? (
        <Link className="sponsor-card__link" to={url} target={openInNewTab ? '_blank' : '_self'}>
          {logoArea}
        </Link>
      ) : (
        logoArea
      )}
      {showTitle && (
        <div className="sponsor-card__body">
          <h4 className="sponsor-card__name">{name}</h4>
        </div>
      )}
    </div>
  );
}

export default SponsorCard;
